<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs
        v-model="tab"
        centered
        grow
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
           href="#pendientes"
          @click="actualizarItems('pendientes')"
        >
          Interpretaciones Pendientes
        </v-tab>

        <v-tab
           href="#historial_interpretaciones"
          @click="actualizarItems('historial_interpretaciones')"
        >
          Historial de Interpretaciones
        </v-tab>
      </v-tabs>
          
      <v-tabs-items v-model="tab">
        <v-tab-item value="pendientes">
          <InterpretacionesPendientes
            ref="pendientes"
          ></InterpretacionesPendientes>
        </v-tab-item>

        <v-tab-item value="historial_interpretaciones">
          <HistorialInterpretaciones
            ref="historial_interpretaciones"
          ></HistorialInterpretaciones>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import InterpretacionesPendientes from './InterpretacionRadiologica/InterpretacionesPendientes.vue';
import HistorialInterpretaciones from './InterpretacionRadiologica/HistorialInterpretaciones.vue'
//import { mapState } from 'vuex'

export default {
  computed: {
    //...mapState(['ids_vistas'])
  },
  components:{
    InterpretacionesPendientes,
    HistorialInterpretaciones
  },
  data: () => ({
    tab: 'pendientes'
  }),
  methods: {
    getItems(){
      this.actualizarItems(this.tab);
    },
    actualizarItems(refName) {
      if (this.$refs[refName] && this.$refs[refName].getItems) {
        this.$refs[refName].getItems();
      } else {
        console.warn(`No se encontró la referencia: ${refName}`);
      }
    }
  }
}
</script>